<template>
    <div class="CommunityContent scrollView" v-if="data">



        <div v-if="data.media_type ==2 || data.media_type==3">
            <video
                    style="width: 100%; display: block"
                    :src="data.video_url"
                    controls
                    x5-video-player-fullscreen='true'
                    x-webkit-airplay='true'
                    webkit-playsinline='true'
                    playsinline='true'
                    x5-playsinline
                    autoplay
                    :poster="data.video_img"></video>
        </div>




        <h1 class="community-Title" >
            {{data.title}}
        </h1>

        <div class="community-list-head">
            <div class="community-list-head-left"  >
                <div class="community-list-head-avatar">
                    <img :src="data.head_img+'?x-oss-process=image/resize,m_fill,h_100,w_100'"  class="community-list-head-avatar-img1">
                    <img  src="../assets/vip.svg" class="community-list-head-avatar-img2">
                </div>

                <div class="community-list-head-account">
                    <div class="community-list-head-account-name">{{data.username}}</div>
                    <div class="community-list-head-account-info">
                        <span>{{timestampToTime(data.create_time*1000).day}}</span>

                    </div>
                </div>

            </div>

        </div>

        <div class="content">





            <div class="community-list-content font-nomal" v-html="data.content"></div>
            <div class="img_one" v-if="data.media_type==1 && data.img.length ===1">
                <img :src="data.img[0]">
            </div>
            <div class="community-list-imgs"  v-else-if="data.media_type==1 && data.img && data.img.length >1">
                <img v-for="(item,index) in data.img" :src="item+'?x-oss-process=image/resize,m_fill,h_200,w_200'" @click="viewimg(index)" tapmode>
            </div>




        </div>


    </div>
</template>

<script>
    import { ImagePreview } from 'vant';
    import layVideo from '@/components/Video.vue'
    import config from '../config'
    import utils from '../utils'
    import { Toast } from 'vant';
    import request from "../utils/request";
    var $ = require("jquery");
    export default {
        name: "CommunityContent",
        components: {
            layVideo,
            [ImagePreview.Component.name]: ImagePreview.Component,
        },
        data(){
            return {
                id:this.$route.params.id,
                data:false,
                played:false
            }
        },
        created() {
            this.getdata()
        },
        methods:{
            playVideo(){
                this.played = true
            },
            timestampToTime(time){
                return utils.timestampToTime(time)
            },
            viewimg(index){
                if(!this.data.img || this.data.img.length===0){
                    return
                }
                ImagePreview({
                    images: this.data.img,
                    startPosition: 1,
                });
            },
            //获取数据
            getdata(){
                request.CommuntyArticleContent(this.id,(res,err)=>{
                    if(res && res.code==200){
                        request.getWeixinShanre(location.href,(s_res)=>{
                            try{
                                let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
                                let shareconfig = {appId,timestamp,nonceStr,signature};
                                let sharedata = {
                                    title:res.data.title ?res.data.title:res.data.content,
                                    desc:res.data.content,
                                    link:location.href,
                                    imgUrl:thumb
                                };
                                if(utils.is_weixin()){
                                    utils.setWeiXinShare(sharedata,shareconfig)
                                }else{
                                    console.log('不是微信')
                                }
                            }catch (e) {
                            }
                        });

                        res.data.content = utils.TextAreaText2Html(res.data.content)
                        this.data = res.data;
                        this.showloading = false;
                        this.replaynumber = res.data.comment_count;
                        this.praised = res.data.is_parise;


                        if(res.data.video_url){

                        }
                        this.$forceUpdate()

                    }else{
                        APP.alert("请求数据失败")
                    }

                });
            },
        }
    }
</script>

<style scoped>
    .show .scrollView{ display: block}
    .community-list-head{ padding: 13px; padding-bottom:0}
    .community-Title{ font-size: 18px; padding:20px 15px; padding-bottom: 0;letter-spacing: 1px; line-height: 1.6}
    .van-info{background-color: transparent; color: #9c9c9c; border:none}
    .video-placeholder{ box-sizing: content-box; height:200px; background-color: #000 }
    .community-list-head-right{ padding: 0 10px; background-color: #FF3638;line-height: 24px !important; color: #fff !important; font-size: 12px; border-radius: 4px;}
    .community-list-head-right.followed{background-color: rgba(0,0,0,0.1); color: #fff !important}

    .more .community-list-head{ display: none}
    .more .community-list-content{ color: #9c9c9c}
    .more-head{ padding: 0 15px; font-size: 18px; margin-top: 20px; display: flex; align-items: center; height: 40px}
    .more-head>div{ width: 5px; height: 24px; background-color: red; margin-right: 5px;}
    .loadmore{ height: 50px; display: flex; justify-content: center; align-items: center; font-size: 14px; color: #323232; background-color:  #f7f7fa}
    .img_one img{ width: 100%}
</style>
